import React, { useState } from 'react'

import { Box, Button, Grid, InputLabel } from '@material-ui/core'
import {
  CalendarToday,
  Close,
  ExpandMore,
  ExpandLess,
} from '@material-ui/icons'
import { KeyboardDatePicker } from '@material-ui/pickers'
import { Controller, useFormContext } from 'react-hook-form'

import SelectMapComponent from './components/SelectMapComponent'

import useFetch from 'hooks/useFetch'

import * as service from 'service'
import constants from 'constants/index'
import useStyles from './styles'

const IncidentReportFilters = () => {
  const classes = useStyles()
  const [open, setOpen] = useState(false)
  const [calendarOpen, setCalendarOpen] = useState(false)

  const { control, errors, watch, setValue } = useFormContext()
  const createdAt = watch('createdAt')

  const { STATUS_LIST, INCIDENT_VIOLATION_TYPES } = constants.incidents

  const { STEPS_LIST } = constants.incidentManegement

  const { response } = useFetch(
    service.dponet.usersCompanies.list,
    {
      listByCompany: true,
      showSelf: true,
      perPage: 100000,
    },
    [],
  )
  const users = response?.data?.userCompanies || []

  const allUsers = users?.map((item) => item.user)

  const handleClick = () => {
    setOpen((open) => !open)
  }
  return (
    <Box>
      {open && (
        <form id="incident-form">
          <Grid container spacing={3}>
            <Grid item xs={6}>
              <InputLabel className={classes.label}>
                Data de criação (opcional)
              </InputLabel>
              <Controller
                defaultValue={null}
                as={
                  <KeyboardDatePicker
                    className={classes.input}
                    fullWidth
                    inputVariant="outlined"
                    format="DD/MM/yyyy"
                    helperText={errors?.createdAt?.message}
                    error={!!errors.createdAt}
                    disableFuture
                    open={calendarOpen}
                    onOpen={() => setCalendarOpen(true)}
                    onClose={() => setCalendarOpen(false)}
                    KeyboardButtonProps={{
                      disableRipple: true,
                      className: classes.keyboardButton,
                    }}
                    keyboardIcon={
                      <>
                        {!!createdAt && (
                          <Close
                            fontSize="small"
                            className={classes.clearIcon}
                            onClick={(event) => {
                              event.stopPropagation()
                              setValue('createdAt', null)
                            }}
                            onMouseDown={(event) => event.stopPropagation()}
                          />
                        )}
                        <CalendarToday fontSize="small" />
                      </>
                    }
                  />
                }
                control={control}
                onChange={([date]) => date}
                name="createdAt"
              />
            </Grid>

            <SelectMapComponent
              name="incidentViolationTypeId"
              label="Origem do Incidente"
              item={INCIDENT_VIOLATION_TYPES}
            />

            <SelectMapComponent
              name="responsibleUserId"
              label="Usuário Responsavel"
              item={allUsers}
            />

            <SelectMapComponent name="steps" label="Fase" item={STEPS_LIST} />

            <SelectMapComponent
              name="tratamentStatus"
              label="Tratamento"
              item={STATUS_LIST}
            />
          </Grid>
        </form>
      )}
      <Button
        variant="text"
        startIcon={open ? <ExpandLess /> : <ExpandMore />}
        onClick={handleClick}
        color="primary"
      >
        {open ? 'Ocultar' : 'Filtros'}
      </Button>
    </Box>
  )
}

export default IncidentReportFilters
